import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";

export function WalletAdoptionTile() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/admin/wallet-adoption")
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, []);

  if (!data) return null;
  const total = (data.apple_passes_downloaded || 0) + (data.google_passes_saved || 0);
  if (!data.apple_enabled && !data.google_enabled && total === 0) return null;

  return (
    <div
      className="mt-4 rounded-xl border border-[#E5E0D8] bg-white px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2"
      data-testid="wallet-adoption-tile"
    >
      <div className="flex items-center gap-2">
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#4A5C50]">Wallet adoption</span>
      </div>
      <div className="flex items-center gap-1.5" data-testid="wallet-adoption-apple">
        <span className={`w-1.5 h-1.5 rounded-full ${data.apple_enabled ? "bg-[#184A30]" : "bg-[#CBA35C]"}`} />
        <span className="text-xs text-[#4A5C50]">Apple</span>
        <span className="mono text-sm text-[#112318]">{data.apple_passes_downloaded}</span>
        <span className="text-[10px] text-[#4A5C50]">downloaded · {data.apple_devices_registered} devices</span>
      </div>
      <div className="flex items-center gap-1.5" data-testid="wallet-adoption-google">
        <span className={`w-1.5 h-1.5 rounded-full ${data.google_enabled ? "bg-[#184A30]" : "bg-[#CBA35C]"}`} />
        <span className="text-xs text-[#4A5C50]">Google</span>
        <span className="mono text-sm text-[#112318]">{data.google_passes_saved}</span>
        <span className="text-[10px] text-[#4A5C50]">saved</span>
      </div>
      {!data.apple_enabled && !data.google_enabled && (
        <span className="text-[10px] text-[#8C6B21] mono">
          Set wallet env vars to enable
        </span>
      )}
    </div>
  );
}
